import { enumValidator } from '#validation/common/validators';
import { ExternalUsersSsoEnforcement } from '../constants';
export const ssoExternalUserEnforcementValidator = enumValidator({
    values: ExternalUsersSsoEnforcement,
    invalidValueError: 'sso.externalUserEnforcement.invalid',
});
